export const downloadFileByUrl = (url: string, fileName: string) => {
  const link: HTMLAnchorElement = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
}

export const downloadFileFromAxiosCall = (response: any, fileName: string) => {
  const url: string = window.URL.createObjectURL(new Blob([response.data]));
  return downloadFileByUrl(url, fileName);
};
